<template name="footerMenuExternal">
  <div class="fixed-bottom footer-menu-external" :class="isContactSelectShow ? 'contact-select-active' : ''" v-show="this.traningCourseStatus">
    <div class="row" :class="this.memberRole === '2' ? 'list-4':''">
      <div class="col-4 invite" @click="openVisitList" v-if="isDetailPage">
        <i class="iconfont icon-invite"></i><span>{{$t('InvitationList')}}</span>
      </div>
      <div class="col-4 invite" v-else>
        <router-link :to="'/external/detailIndex/' + trainingId + '/0?inviteList=true'">
          <i class="iconfont icon-invite"></i><span>{{$t('InvitationList')}}</span>
        </router-link>
      </div>
      <div class="col-4 training">
        <router-link :to="'/external/training/' + trainingId + '/0'">
          <i class="iconfont icon-training"></i><span>{{$t('TrainingList')}}</span>
        </router-link>
      </div>
      <div class="col-4 application" v-if="this.memberRole === '2'">
        <router-link :to="'/external/carrier-new-application/' + trainingId + '/0'">
          <i class="iconfont icon-add"></i><span>{{$t('NewApplication')}}</span>
        </router-link>
      </div>
      <div class="col-4 guide">
        <router-link :to="`/external/guide/${trainingId}`">
          <i class="iconfont icon-guide"></i><span>{{$t('OperationGuide')}}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import myAuth from '@/utils/auth';
export default {
  name: 'footerMenuExternal',
  props: {
    trainingId: String,
    isContactSelectShow: Boolean,
    isDetailPage: Boolean,
  },
  data() {
    return {
      traningCourseStatus: true,
      memberRole: '',
    }
  },
  methods: {
    openVisitList() {
      this.$emit('changeVisitListStatus',true);
    },
  },
  created() {
    this.memberRole = myAuth.getLocalUserRole();
  },
  mounted () {
    const that = this;
    var windowInnerHeight = window.innerHeight;
    window.onresize = () => {
      if(window.innerHeight < windowInnerHeight){
         that.traningCourseStatus = false;
      }else{
         that.traningCourseStatus = true;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@import '../scss/variables.scss';
.footer-menu-external {
  display: none;
  background: #fff;
  .iconfont {
    font-size: 18px;
    color: #c9c9c9;
    padding-right: 5px;
  }
  a:hover {
    text-decoration: none;
  }
  @include respond-to('sm-max') {
    display: block;
    &.fixed-bottom {
      position: fixed;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1030 !important;
      background: #fff;
    }
    &.contact-select-active {
      display: none;
    }
    width: 100%;
    padding: 15px 20px;
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
    .row {
      align-items: center;
      text-align: center;
      div {
        cursor: pointer;
        padding-left: 0;
        padding-right: 0;
      }
      img {
        margin-right: 5px;
      }
      span {
        color: #4a4a4a;
        font-size: 13px;
      }
    }
  }
  @include respond-to('ml') {
    display: block;
    &.fixed-bottom {
      position: fixed;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1030 !important;
      background: #fff;
    }
    &.contact-select-active {
      display: none;
    }
    width: 100%;
    padding: 15px 20px;
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
    .row {
      align-items: center;
      text-align: center;
      div {
        cursor: pointer;
      }
      img {
        margin-right: 5px;
      }
      span {
        color: #4a4a4a;
        font-size: 13px;
      }
    }
  }
}
.show-invite-list {
  .footer-menu-external {
    z-index: 9999;
    .row .invite {
      span,
      i {
        color: #e42029;
      }
    }
  }
}
.page-training {
  .footer-menu-external {
    .row .training {
      span,
      i {
        color: #e42029;
      }
    }
  }
}
.page-guide {
  .footer-menu-external {
    .row .guide {
      span,
      i {
        color: #e42029;
      }
    }
  }
}
.page-carrierNewApplication {
  .footer-menu-external {
    .row .application {
      span,
      i {
        color: #e42029;
      }
    }
  }
}
.list-4 .col-4 {
  flex: 0 0 25%;
  max-width: 25%;
}
</style>
